/*
 * Copyright (c) 2022 OTB Africa. All rights reserved. <https://otbafrica.com>
 *
 * Created Date: Thursday, June 30th 2022, 10:39:25 am
 * Author: OTB Africa, developers@otbafrica.com
 *
 * Use of this source code is governed by the license that can be found in
 * the LICENSE file or at https://developers.otbafrica.com/licenses/
 */

import { DataTable } from "ui-widgets";
import { OrganizationListItem } from "lib/schemas";
import { APISERVICEPATHS } from "lib/api";
import { OrganizationCard } from "./OrganizationCard";

export interface OrganizationSwitcherGridListProps {
  switchOrganization: (selectedOrganization: OrganizationListItem) => void;
  selectedOrganization: OrganizationListItem;
}

export const OrganizationSwitcherGridList = ({
  switchOrganization,
  selectedOrganization,
}: OrganizationSwitcherGridListProps) => {
  return (
    <DataTable<OrganizationListItem>
      title="Organizations"
      dataSource={APISERVICEPATHS.workerOrganizations}
      uniqueKey="id"
      defaultOrderBy="name"
      initialRowsPerPage={10}
      unit="Organization"
      titleKey="name"
      searchKeys={["name"]}
      listViewMode="grid"
      renderGridItem={(organization) => (
        <OrganizationCard
          onClick={() => switchOrganization(organization)}
          organization={organization}
          actionText={<>Switch</>}
        />
      )}
      showToolbar={false}
    />
  );
};
